import React, { Suspense } from 'react'

import { useParams } from 'react-router-dom'

import { Box, CircularProgress } from '@mui/material'

import { useBackButton } from '@/hooks/useBackButton'
import { useAuth } from '@/hooks/useAuth'

import ChargingPointScreen from '@/modules/ChargingPoint/ChargingPointScreen'
import ChargingPointAccessGate from '@/modules/ChargingPoint/components/AccessGate'

import { useQueryAccessContext } from '@/api/access-codes/queries'

import { AppRoutes } from '@/routes/types/routes'
import { routeParser } from '@/routes/helpers/parser'

const ChargingPointPageLoading: React.FC = () => (
  <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
    <CircularProgress />
  </Box>
)

const ChargingPointPage: React.FC = () => {
  const params = useParams()
  const { isAuthenticated } = useAuth()

  useBackButton({ backRoute: routeParser(AppRoutes.STATION_CHARGERS, { stationId: Number(params.stationId) }) })

  const rawChargingPointId = Number(params.chargingPointId)
  const chargingPointId = isNaN(rawChargingPointId) ? 0 : rawChargingPointId

  const { data: accessContext, isLoading: isLoadingAccessContext } = useQueryAccessContext(
    { chargingPointId },
    { enabled: isAuthenticated && !!chargingPointId }
  )

  if (isAuthenticated && isLoadingAccessContext) {
    return <ChargingPointPageLoading />
  }

  if (accessContext && !accessContext.has_access) {
    return <ChargingPointAccessGate context={accessContext} chargingPointId={chargingPointId} />
  }

  return (
    <Suspense fallback={<ChargingPointPageLoading />}>
      <ChargingPointScreen />
    </Suspense>
  )
}

export default ChargingPointPage
